module.exports = __webpack_public_path__ + "static/media/job_date.c6df9c7c.svg";